var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "update-package" }, [_c('el-schema-form', { ref: "form", attrs: { "schema": _vm.schema, "model": _vm.model, "auto-update": true } }), _vm._v(" "), _c('div', { staticClass: "update-package-ft" }, [_c('el-button', _vm._b({ on: { "click": _vm.handleCancel } }, 'el-button', _vm.cancelButton, false), [_vm._v("取 消")]), _vm._v(" "), _c('el-button', _vm._b({ on: { "click": _vm.handleSubmit } }, 'el-button', _vm.submitButton, false), [_vm._v("提 交")])], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };